module.exports = __webpack_public_path__ + "static/media/carolina-herrera.b445dd1b.jpg";